// @flow
import PropTypes from 'prop-types';
import styled from 'styled-components';
import throttle from 'lodash/throttle';

import type { ButtonTheme } from '../typings';
import { BUTTON_HEIGHT, ANIMATION_DURATION_CSS } from '../../constants';

import DisplayText from './Text/DisplayText';

/* eslint-disable */
const StyledButton = styled.button`
  height: ${BUTTON_HEIGHT};
  width: ${props => props.width || 'auto'};
  background-color: ${props =>
    (props.buttonTheme && props.theme.button[props.buttonTheme].bg) ||
    props.theme.btnBrand};
  transition: background-color ${ANIMATION_DURATION_CSS} ease-in-out;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: ${props => (props.withMargin ? 10 : 0)}px;

  &:active {
    background-color: ${props =>
      (props.buttonTheme && props.theme.button[props.buttonTheme].bgClicked) ||
      props.theme.btnBrandClicked};
  }

  &:hover {
    background-color: ${props =>
      (props.buttonTheme && props.theme.button[props.buttonTheme].bgHover) ||
      props.theme.btnBrandHover};
  }

  &:focus {
    outline: 0;
  }
`;

const Label = styled(DisplayText)`
  color: ${props =>
    props.theme[props.themeColor] ||
    (props.buttonTheme && props.theme.button[props.buttonTheme].text) ||
    '#FFF'};

  ${StyledButton}:active & {
    color: ${props =>
      props.theme[props.themeColor] ||
      (props.buttonTheme &&
        props.theme.button[props.buttonTheme].textClicked) ||
      props.theme.brand};
  }
`;
/* eslint-enable */

type Props = {
  onPress: Function,
  label: string,
  width?: string,
  buttonTheme: ButtonTheme,
  themeColor?: string
};

export default function Button({ label, buttonTheme, themeColor, onPress, ...restProps }: Props) {
  const onClick = throttle(onPress, 500);

  return (
    // $FlowFixMe
    <StyledButton buttonTheme={buttonTheme} onClick={onClick} {...restProps}>
      <Label fontSize="14px" bold buttonTheme={buttonTheme} themeColor={themeColor}>
        {label}
      </Label>
    </StyledButton>
  );
}

Button.propTypes = {
  label: PropTypes.string,
  width: PropTypes.string,
  themeColor: PropTypes.string,
  buttonTheme: PropTypes.string,
  onPress: PropTypes.func
};
